import axios from 'lib/axios'

interface ActivationLinkResponse {
  status: string
  data: { link: string }
}

export const issueActivationLink = async (companyId: number, userId: number): Promise<string> => {
  const response = await axios.post<ActivationLinkResponse>(
    `/company/${companyId}/process/user/${userId}/activation-link`
  )

  return response.data.data.link
}
